// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border-table[data-v-5d1a1ba3] .el-table__header th,.no-border-table[data-v-5d1a1ba3] .el-table__row td{border-bottom:none}.no-border-table[data-v-5d1a1ba3] .el-table__body{border-collapse:separate;border-spacing:0}", ""]);
// Exports
module.exports = exports;
